import { useState, useEffect } from 'react';
import { getScoresForPost } from 'services/recruitersService';

const useScoreStatistics = (userId, apiUrl) => {
  const [postsData, setPostsData] = useState({});
  const [selectedPost, setSelectedPost] = useState("");
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Color scheme
  const colors = ["#B0C4DE", "#000080", "#4169E1"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getScoresForPost(userId, apiUrl);
        setPostsData(data);
        if (Object.keys(data).length > 0) {
          setSelectedPost(Object.keys(data)[0]);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userId, apiUrl]);

  useEffect(() => {
    if (selectedPost && postsData[selectedPost]) {
      const postData = postsData[selectedPost];
      const totalScores = postData.bad + postData.moyen + postData.excellent;
      const labels = ["Bad", "Average", "Excellent"];
      const data = [postData.bad, postData.moyen, postData.excellent];
      const percentages = data.map((value) =>
        ((value / totalScores) * 100).toFixed(1)
      );

      setChartData({
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors,
            hoverBackgroundColor: colors.map((color) => `${color}CC`),
            borderWidth: 1,
            borderColor: colors.map((color) => `${color}99`),
            offset: 4,
            shadowOffsetX: 0,
            shadowOffsetY: 4,
            shadowBlur: 1,
            shadowColor: "#0000000D",
          },
        ],
        percentages,
      });
    }
  }, [selectedPost, postsData]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || "";
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
    cutout: "60%",
    radius: "100%",
    layout: {
      padding: 20,
    },
    elements: {
      arc: {
        borderWidth: 0,
        borderRadius: 5,
      },
    },
  };

  return {
    postsData,
    selectedPost,
    setSelectedPost,
    chartData,
    chartOptions,
    loading,
    error,
    colors
  };
};

export default useScoreStatistics;